export const config = [
    {
        key: "story",
        urlParams: "story",
        component: "webNews",
        getHistory: {
            url: "/cm-sites-pms/story/getStoryHistory",
            method: "get",
            idKey: "storyId"
        }
    },
    {
        key: "webNews",
        urlParams: "webNews",
        component: "webNews",
        getHistory: {
            url: "/cm-sites-pms/website/news/getWebNewsHistory",
            method: "get",
            idKey: "webNewsId"
        }
    },
    {
        key: "mediaFusion",
        urlParams: "mediaFusion",
        component: "webNews",
        getHistory: {
            url: "/cm-sites-mmp/mf/getMediaFusionHistory",
            method: "get",
            idKey: "mediaFusionId"
        }
    },
    {
        key: "material",
        urlParams: "material",
        component: "material",
    },
    {
        key: "weibo",
        urlParams: "weibo",
        component: "weibo",
    },
    {
        key: "kuaishou",
        urlParams: "kuaishou",
        component: "kuaishou",
    },
];